import { createBrowserHistory } from 'history'
import { configureStore } from '@reduxjs/toolkit'
import { createSelectorHook, createStoreHook, useDispatch as DispatchHook } from 'react-redux'
// import logger from 'redux-logger'
import { routerMiddleware } from 'connected-react-router'

import RootReducer from './rootReducer'
import { refreshTokenThunk } from './auth/thunks'
import { appLogOutAction } from './auth/slice'

export const history = createBrowserHistory()

export const store = configureStore({
  reducer: RootReducer(history),
  devTools: process.env.NODE_ENV === 'development',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['uploadImages'],
        ignoredActionPaths: ['meta.arg', 'payload.images']
      }
    }).prepend(routerMiddleware(history))
  // .concat(logger)
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const useSelector = createSelectorHook<RootState>()
export const useStore = createStoreHook<RootState>()
export const useDispatch = () => DispatchHook<AppDispatch>()

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./rootReducer', () => {
    const newRootReducer = require('./rootReducer').default
    newRootReducer(history)
    store.replaceReducer(newRootReducer)
  })
}

export const authCallbacks = {
  refreshToken: () => store.dispatch(refreshTokenThunk()),
  appLogOut: () => store.dispatch(appLogOutAction())
}
